// removed by extract-text-webpack-plugin
module.exports = {"AdsSlider":"AnIa3F02VDDJDBOKurr4o","AdsSlider__ads":"_2EdYS8RNV4oVR6_9-7_1mr","AdsSlider__controls":"_1c0XUC2r-nihP9H9JyUw7t","AdsSlider__controls--disabled":"_3GxrpPTqZclHcUG7q_Zh-v","AdsSlider__control":"_3riaQf6hmsMWd9s8AArcoC","AdsSlider__control--left":"_1YpdQL7M5s4y7Kcl_2HaAT","AdsSlider__control--right":"_3o16IYfaT5QsnYlKhPJFh6","Ad":"_27_cIDFax3IIwRGdVL5w0R","Ad--current":"_1SNFhyZDsTv6Or5yr9Z_CR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdsSlider/AdsSlider.scss
// module id = 2370
// module chunks = 0